module.exports = __webpack_public_path__ + "img/banner.7eb277e7.jpg";